import { useQuery } from "@tanstack/react-query";
import { get } from "../../api/util";
import { FirmaDto } from "../../interfaces/schema";
import SuperDropdown, { SuperDropdownItem } from "../dropdown/SuperDropdown";
import DefaultDropdownItem from "../dropdown/DefaultDropdownItem";
import Spinner from "../spinner/Spinner";
import { UseComboboxStateChange } from "downshift";

const AutoCompleteRet = ({
  onSelectedItemEvent,
  onBlur,
  focusInputOnMount,
}: {
  onSelectedItemEvent: (
    event: UseComboboxStateChange<SuperDropdownItem<FirmaDto, "id">>,
  ) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  focusInputOnMount?: boolean | undefined;
}) => {
  const { data, error, isPending } = useQuery({
    queryKey: ["retter"],
    queryFn: async () =>
      get<FirmaDto[]>({
        query: "retter",
      }),
  });
  if (error) return <div>Fejl</div>;
  if (isPending) return <Spinner size={24} />;
  if (!data) return null;

  return (
    <SuperDropdown
      items={data}
      itemsIdKey="id"
      itemToElement={(item) => <DefaultDropdownItem label={item.navn1 ?? ""} />}
      itemToString={(item) => item?.navn1 ?? ""}
      onSelectedItemEvent={onSelectedItemEvent}
      placeholder="Ingen"
      filterKeys={["navn1"]}
      classNameContainer="w-100"
      onBlur={onBlur}
      focusInputOnMount={focusInputOnMount}
    />
  );
};

export default AutoCompleteRet;
